import ActivePlan from "../../slices/plans/active_plan/ActivePlan"
import FuturePlan from "../../slices/plans/future_plan/FuturePlan"
import PlanHistory from "../../slices/plans/plan_history/PlanHistory"

const plansReducer = {
    activePlan: ActivePlan,
    futurePlan: FuturePlan,
    planHistory: PlanHistory,
};

export default plansReducer;
